import {
	fundAccount,
	ipsProductId,
	ipsLoProductId,
	livrenteProductId,
	loProductId,
	oldIpsProductId,
	oldPensjonskontoProductId,
	pensjonskontoProductId,
	pensjonskontoLoProductId,
} from "~/utils/policies";

export const paymentTermTexts = (productId, hasSavingAmount) => {
	switch (productId) {
		case oldIpsProductId:
		case fundAccount:
		case livrenteProductId:
			return "Når utbetaling starter stanses innbetalingene til avtalen din. " + "Vennligst slett betalingsavtalen i nettbanken din dersom denne fortsatt er aktiv.";
		case loProductId:
		case oldPensjonskontoProductId:
			return (
				"Dersom du velger å starte månedlig utbetaling av denne avtalen mister du retten til " +
				"betalingsfritak ved uførhet og fremtidige innbetalinger til avtalen vil opphøre. " +
				"Vennligst slett betalingsavtalen i nettbanken din dersom denne fortsatt er aktiv."
			);
		case pensjonskontoProductId:
		case pensjonskontoLoProductId:
			return hasSavingAmount
				? "Når utbetaling starter stanses innbetalingene til avtalen din. " + "Vennligst slett betalingsavtalen i nettbanken din dersom denne fortsatt er aktiv."
				: "Dersom du ønsker å stanse sparingen etter at utbetaling har startet fryser du bare " + "sparingen på detaljsiden for din Pensjonssparekonto.";
		case ipsProductId:
		case ipsLoProductId:
			return [
				hasSavingAmount ? "Når utbetaling starter stanses innbetalingene til avtalen din. " : "",
				"Vennligst slett betalingsavtalen i nettbanken din dersom denne fortsatt er aktiv.",
			].join("");
		default:
			return null;
	}
};
